import { create } from "zustand";
import { OrdenServicio } from "../../types";

type useModalInfoTrasladoLocalidadStoreState = {
  open: boolean
  setOpen: (value: boolean, data: OrdenServicio | null) => void
  data: OrdenServicio | null
  handleClose: ()=>void
}

const useModalInfoTrasladoLocalidadStore = create<useModalInfoTrasladoLocalidadStoreState>((set) => ({

  handleClose() {
    set({
      open: false,
      data: null
    })
  },
  data: null,
  open: false,
  setOpen(value, data) {
    set({
      open: value,
      data
    })
  },

}))

export default useModalInfoTrasladoLocalidadStore
